var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "34px",
    viewBox: "0 0 46 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "green-tick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "green-tick",
    transform: "translate(4.000000, 4.000000)",
    fill: "#2DCA73",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2521359,-2.11570427 C35.8015179,-3.69041394 38.3340946,-3.71094608 39.9088043,-2.16156408 C41.4310236,-0.663828151 41.5009504,1.7526486 40.1043698,3.33451231 L39.9546641,3.49510427 L15.7299641,28.1158043 C14.2150285,29.6555045 11.764714,29.7068289 10.1874185,28.2697767 L10.0274384,28.1158068 L-1.95471159,15.9378068 C-3.50409499,14.3630985 -3.4835651,11.8305218 -1.9088568,10.2811384 C-0.386638787,8.78340113 2.03065405,8.75266059 3.58966783,10.1747035 L3.74781159,10.3269932 L12.878,19.606 L34.2521359,-2.11570427 Z",
    id: "Path"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.f4681cc553ba53db7aa492d22ccb5258.svg";
export { ForwardRef as ReactComponent };